export const api = `${import.meta.env.VITE_API_ENDPOINT}`;
export const url = `kloud`;
export const apiCode = import.meta.env.VITE_API_ENDPOINT_CODE;
export const azureRedirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin;
